<template>
  <div style="border-bottom: 1px dashed #eee;padding-bottom: 10px">
    <div class="_5118-chart">
      <div class="chart" :class="{'chart-none':isNot,'chartbox':isbaidu}">
        <a class="chart-svg" :id="id"></a>
      </div>
    </div>
  </div>
</template>

<script>
  import HighCharts from 'highcharts'
  import {format} from "../assets/script/util"

  let options = {
    chart: {
      animation: false,
      backgroundColor: null,
      borderWidth: 0,
      type: 'area',
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: 20,
      style: {
        overflow: 'visible'
      },
      skipClone: true
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      labels: {
        enabled: false
      },
      startOnTick: false,
      endOnTick: false,
      tickPositions: [],
      lineWidth: 0
    },
    yAxis: {
      endOnTick: true,
      startOnTick: true,
      labels: {
        enabled: false
      },
      title: {
        text: null
      },
    },
    legend: {
      enabled: false
    },
    tooltip: {
      shared: true,
      formatter: function () {
			return '<b>' + this.x + '</b><br/>外链数: ' + this.y;
		  }
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false
            }
          }
        },
        lineWidth: 1
      }
    }
  };

  export default {
    componentName: "Chart",
    props: {
      id: String,
      title: String,
      data: Object,
      isbaidu:{
        default: false
      },
    },
    watch: {
      data: {
        handler: function (newVal) {
          this.init()
        },
        deep: true
      }
    },
    data() {
      return {
        isNot: false,
        list: [],
      }
    },
    computed: {
      jump_domain_url: {
        get() {
          return this.$store.state.menu.jump_domain_url;
        },
        set(val) {
          this.$store.state.menu.jump_domain_url = val;
        }
      },
      logged: {
        get() {
          return this.$store.state.user.logged
        }
      },
    },
    mounted() {
      this.init()
    },
    methods: {

      init() {
        try {
          this.isNot = false;
          let xSeries = [];
          if(this.data.date==null || this.data.date.length==0){
            this.isNot = true;
          }

          if (!this.data.date) {
            return
          }

          for (let date of this.data.date.reverse()) {
            xSeries.push(format(new Date(date), 'MM/dd'));
          }


          options.xAxis.categories = xSeries;
          options.yAxis.min = Math.min.apply(Math,this.data.result)
          options.yAxis.max = Math.max.apply(Math,this.data.result)
 ;
          options.series = [{
            data: this.data.result.reverse(),
            color: '#4D9AE8',
            fillOpacity: '0.1'
          }];
          this.list = options.series;
          HighCharts.chart(this.id, options);
        } catch (e) {
          console.error(e);
          this.isNot = true
        }
      },
    }
  }
</script>


<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .chart-title {
    color: #3a4f70;
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 10px;
  }

  ._5118-chart {
    width: 100%;
    height: 130px;
    position: relative;
    overflow: hidden;
    .chart {
      width: 225px;
      height: 130px;
      float: left;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAAeCAMAAADKK8opAAAASFBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABpD+GFAAAAGHRSTlMAAAECAwQFBgcICQoLDA0ODxAREhMUFRiYLTOhAAACqklEQVR4XuXViarcOBAF0JvSYmuzalG/+f8/nRbGy3QY6IQ0D8gB8MWoqEIuMH58g+9p+gfFuvVWHN5GF/ye0Id2VuvvdqXK/cAc8RsWG5lATW3Fe8qQi4rDLwtqaYasGvEWr8IsJ2v4Zc2YABBbpzcrlEX6icXjJuY0rdnjiXxci8NLdCwSAbQhHm+JyqIL3eCGZNg0zAPUlWUI4RYnLyIcXX2wx3u6shX8n2QioqojAXC5zAFxi7uqLMKaCO9JxsKE0OqplbOYlEMIyxN2rB0/x6gqLBLwHifCtgI89DIKdsiPiLukmn6OWaV2ZbGIC3mHyXtMBMwwX6LoHBjZ5MKi/hiJYwiEU1dxr9FtDw7wm7A2HKgwSwPW+SAslXvXljaVBUGZLcKx8M1ZXYznEPl2jfU1Eg+mGTaR7bpAXbxl1JGofOVZmNdu21pGw6Y8a8m7g/dUhfcV8aaiKjLyuTAaX2M1DZiyngtJogTXkL5WYP0q8KMAmwLxkcEiQnjRhS3P4FMIsQgL0zF/x3SLQY5r2VTDuQrrPnQHUB8RdXiEUYHNHLIJ55sa9ztlh1PRo2kyXYEzHiFjyjoSdsRCZ283Osg2oI4APxtTF9aLWYBXYUu4rKYNk+8qHnvkI64m3QO+DsuY0go3z4FQHwHE5pBGBLQBxRyAxeTCs64pK+Om7r+OLGaqWv8bQc1Me7fRI6b8TwO2h/a+Yhm9sHgUG0vgr81nGyuemspJOyHu+3wJ8zWA1ErOuSUA+YzTWnvfylGyFAJcrnUlYGnzkCs5x1hS8jnnBU8ULpGAvu/zybFJwGclYxGP08JDIv68JadT5v3D7mhpYzSPDygPPZgySyc8+VI2GbYt+Ajqyje2t8kPk5YCPiWq3VRMcN4RPmlt9eLxaT++wd/T9F+GuzYf+0RNTAAAAABJRU5ErkJggg==) no-repeat center center;
      .chart1, .chart2, .chart3, .chart4, .chart-svg {
        display: block;
        width: calc(100%);
        /*margin-left: -22px;*/
        height: 100%;
      }
    }
    .chart-none {
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8CAQAAAA6NtdFAAAChUlEQVRo3u2YMWsVQRSF55lCEHyNCOkEQbR2U4hgaaFYKdbpBvwFj/wCG//AxkbRUrRQsNjORgtBpnfggIEkIJEQCSLJm7B37+7OzptVC9k3q5fT7C6Tfffbc8+d3Sin/g0pAREQAREQAREQAfmLIOjqLnbgItrFLX9d6iDn8S2KUWofq+MBedyLUerJWEDWcMwlf0QR0VucGgPIBO8ZYxPqd0oZZJ0xvuIcFFZxMaozqYOcxTaDPIDCdRz15GQL07RBHnKhn7DiNVlMj1IGuYQfVOQcN6Bw/5ez6yeupAvygot8Smc3MYtqA4e06nW6IN+pwAN/y4toDXNad5guyCsqcKfHiRku06p37Nub9DMS1xxXoXBvDBlpp1ZMz6FwGp/HMLUUpvjSg7GHC1CY8dl26vtI+czje/mU9vl9Blkfx9tvXBM8Y4wPmIwBZAUvo2+9pgn9NfkeSegLcW9MX4gKd3q+2bdwe0zf7H8sAZH/awmIgAjI/wlirMmMMsrkxrFyOncL0nS9oLXaZHTkTHun3GgX/N1AIMZ6P5ozQFeZsQtXClpr+TgEsd793WCOlD/LpbaO2KDsLkaLXpiiOc6aa0txRHtF5dQ6secfuqSp3IyKz6jZdNyRgcPOTVIh1CA2kpGq7JyhLR1V8FkIUjbfgCCdcnUHpFbBo6B1I+ew5+RJeWabjDivQTl5w02t8KkvRt0FcP5YKB9A4erslLNsGY40jdXKBn7oAEQvNJqrGqtqLcpP67MdEqTfkYKD7honqkRoTkq1pgtCg9mfict3xDbzygV5KRpkR9dcG3byKSlH6vD7hTturby7hu6R1Zuq78OgIPLSKCACIiACIiACkqROANaZuAHWy7MVAAAAAElFTkSuQmCC) no-repeat center center;
    }
  }
  .chartbox{
    width: 320px !important;
    height: 130px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Chart2.vue